/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'payment': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<g clip-path="url(#clip0)"><path pid="0" d="M16.125 3H1.875A1.878 1.878 0 000 4.875v8.25C0 14.159.842 15 1.875 15h14.25A1.878 1.878 0 0018 13.125v-8.25A1.878 1.878 0 0016.125 3zm1.125 10.125c0 .62-.505 1.125-1.125 1.125H1.875c-.62 0-1.125-.505-1.125-1.125v-8.25c0-.62.505-1.125 1.125-1.125h14.25c.62 0 1.125.505 1.125 1.125v8.25z"/><path pid="1" d="M17.625 5.25H.375A.375.375 0 000 5.625v2.25c0 .207.168.375.375.375h17.25A.375.375 0 0018 7.875v-2.25a.375.375 0 00-.375-.375zM17.25 7.5H.75V6h16.5v1.5zM7.125 10.5h-4.5a.375.375 0 000 .75h4.5a.375.375 0 000-.75zM7.125 12h-4.5a.375.375 0 000 .75h4.5a.375.375 0 000-.75zM14.625 9.75h-.75c-.62 0-1.125.505-1.125 1.125v.75c0 .62.505 1.125 1.125 1.125h.75c.62 0 1.125-.505 1.125-1.125v-.75c0-.62-.505-1.125-1.125-1.125zM15 11.625a.375.375 0 01-.375.375h-.75a.375.375 0 01-.375-.375v-.75c0-.207.168-.375.375-.375h.75c.207 0 .375.168.375.375v.75z"/></g><defs><clipPath id="clip0"><path pid="2" _fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/payment.js